// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__tXeA-","ranges":"BmiRanges_ranges__JoF6s"};